import React, { useCallback, useMemo, useState } from "react";

export const AlertContext = React.createContext({});

const AlertProvider = ({ children }) => {
  const [alertList, setAlertList] = useState([]);

  const alert = useCallback(
    ({
      id,
      title = "",
      description = "",
      status = "success",
      duration = 5000,
    }) => {
      const uuid = crypto.randomUUID();
      const newAlert = {
        uuid,
        id,
        title,
        description,
        status,
      };

      setAlertList((alertList) => [...alertList, newAlert]);
      setTimeout(() => {
        setAlertList((alertList) =>
          alertList.filter((currentAlert) => currentAlert.uuid !== uuid),
        );
      }, duration);
    },
    [],
  );

  const removeAlert = useCallback((uuid) => {
    setAlertList((alertList) =>
      alertList.filter((currentAlert) => currentAlert.uuid !== uuid),
    );
  }, []);

  const isActive = useCallback(
    (id) => !!alertList.find((currentAlert) => currentAlert.id === id),
    [alertList],
  );

  const contextValue = useMemo(() => {
    alert.isActive = isActive;

    return {
      alertList,
      alert,
      removeAlert,
    };
  }, [alert, alertList, isActive, removeAlert]);

  return (
    <AlertContext.Provider value={contextValue}>
      {children}
    </AlertContext.Provider>
  );
};

export default React.memo(AlertProvider);
